import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import id from './locales/id.json';
import en from './locales/en.json';
import { detectLanguage, DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './language';

i18n.use(initReactI18next).init({
  resources: { id: { translation: id }, en: { translation: en } },
  lng: detectLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES,
  load: 'languageOnly',
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

function updateDocumentLanguage(language) {
  document.documentElement.lang = language;
  document.title = i18n.t('meta.title');
  document.querySelector('meta[name="description"]')?.setAttribute('content', i18n.t('meta.description'));
}
updateDocumentLanguage(i18n.resolvedLanguage || DEFAULT_LANGUAGE);
i18n.on('languageChanged', updateDocumentLanguage);

export default i18n;
